;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.menuClick = (function () {
    const initialize = function () {
      $('.js-menuClick').on('click', function (e) {
        setTimeout(function () {
          $('#spmenu-subnav').removeClass('spmenu-open')
        }, 300)
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.menuClick.initialize()
  })
}(jQuery, window))
